import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

export class AppointmentAnimationState {
    static get initial() { return 'initial'; }
    static get clicked() { return 'clicked'; }
}

export const appointmentAnimations: any[] = [
    trigger('appointmentSuccessCheck', [
        state(AppointmentAnimationState.initial, style({})),

        state(AppointmentAnimationState.clicked, style({})),

        transition(`* => ${AppointmentAnimationState.clicked}`, animate('1s', keyframes([
            style({ 'opacity': '1', offset: 0 }),
            style({ 'opacity': '1', offset: 0.9 }),
            style({ 'opacity': '0', offset: 1 })
        ])))
    ]),
];